<template>

  <transition :name="checkTransition" mode="out-in">
    <div class="productListing vh-for-mobile" :data-variant="variant" @click="closeAllFilter">

      <div class="wrapper">

        <div class="container">

          <div v-if="config.shortText" class="productListing__shortText">
            <p v-html="config.shortText"></p>
          </div>

          <div v-if="config.filters"
               :class="{'productListing__filters': true, 'is-open': !collapsedFilters || config.filtersOpened}">

            <div class="productListing__filters__header" @click="toggleFiltersBox">
              <span>Filtra i risultati</span>
              <div class="productListing__filters__toggle">
                <span :class="{'is-open': !collapsedFilters}"></span>
              </div>
            </div>

            <div class="productListing__filters__content">

              <div v-for="select in config.filters" class="productListing__filter" :data-type="select.key"
                   data-index="0">
                <div class="productListing__filter__header"
                     @click.stop="toggleFilter(select.key)"
                     v-text="getSelectedOption(select.key)"></div>
                <div class="productListing__filter__content">
                  <div v-for="(option, index) in select.options"
                       :key="option.value"
                       :data-value="option.value"
                       :data-index="(index + 1)"
                       :data-selected="isOptionSelected(option)"
                       class="productListing__filter__option"
                       @click="closeFilter(select.key, option.value)">{{option.label}}
                  </div>
                </div>
              </div>

            </div>

          </div>


          <div v-if="previousBrand" class="productListing__info">
            <div class="productListing__info__close" @click="closeInfoBox">&times;</div>
            <div class="productListing__info__title">{{config.info.title}} {{getBrand}}.</div>
            <div class="productListing__info__description">{{config.info.subtitle}}</div>
          </div>

          <div v-if="!checkResolution && !noProducts" class="productListing__paginator">
            <div class="productListing__paginator__label">{{config.paginator.label}}</div>
            <div class="productListing__paginator__list">
              <ul>
                <li v-if="checkTotalPages" :class="{'is-disabled': !checkFirstVisible}" @click="movePagePrev">
                  <span>&laquo</span>
                </li>
                <li v-for="(page, index) in config.paginator.totalPages"
                    v-if="checkIfInRange(index)"
                    :data-index="index"
                    :class="{'is-active': checkIfCurrentPage(index)}"
                    @click.self="checkPage">
                  <span>{{index + 1}}</span>
                </li>
                <li v-if="checkTotalPages" :class="{'is-disabled': !checkLastVisible}" @click="movePageNext">
                  <span>&raquo</span>
                </li>
              </ul>
            </div>
          </div>

        </div>

        <div class="productListing__wrapper">

          <div v-if="checkResolution && !noProducts" class="productListing__paginator">
            <div class="productListing__paginator__label">{{config.paginator.label}}</div>
            <div class="productListing__paginator__list">
              <ul>
                <li v-if="checkTotalPages" :class="{'is-disabled': !checkFirstVisible}" @click="movePagePrev">
                  <span>&laquo</span>
                </li>
                <li v-for="(page, index) in config.paginator.totalPages"
                    v-if="checkIfInRange(index)"
                    :data-index="index"
                    :class="{'is-active': checkIfCurrentPage(index)}"
                    @click.self="checkPage">
                  <span>{{index + 1}}</span>
                </li>
                <li v-if="checkTotalPages" :class="{'is-disabled': !checkLastVisible}" @click="movePageNext">
                  <span>&raquo</span>
                </li>
              </ul>
            </div>
          </div>

          <div class="productListing__list">

            <div v-if="config.suggested" v-for="item in config.suggested" :key="item.Product_ID"
                 class="productListing__item productListing__item--suggested">

              <div class="productListing__item__label">
                <span>consigliato da desivero</span>
              </div>

              <div class="productListing__item__img">
                <img v-if="item.ImageURL"
                     :class="{'productListing__item__img__content': true, 'is-portrait': checkImgSize}"
                     :src="item.ImageURL"
                     :alt="item.Product_Name"/>
              </div>
              <h4 v-if="item.Manufacturer" class="productListing__item__brand">{{item.Manufacturer}}</h4>
              <h5 v-if="item.Category_4" class="productListing__item__model">{{item.Category_4}}</h5>
              <div v-if="item.Product_Name" class="productListing__item__description">{{item.Product_Name}}</div>
              <div v-if="item.delivery" class="productListing__item__delivery">
                <img :src="item.delivery.icon" :alt="item.delivery.label">
                <span>{{item.delivery.label}}</span>
              </div>
              <div v-if="item.Price" class="productListing__item__price">&euro; {{item.Price}}</div>
              <div class="productListing__item__addBtn"
                   @click="retrieveNextStep(config.id, config.answers[0].id, false, item.Product_ID)">
                <span class="productListing__item__addBtn__span">Aggiungi al carrello</span>
              </div>

            </div>

            <div v-for="item in config.products" :key="item.Product_ID" class="productListing__item">

              <div :data-visible="isInCart(item)" class="productListing__item__cart">
                <span>nel carrello</span>
              </div>

              <div class="productListing__item__img">
                <img v-if="item.ImageURL" class="productListing__item__img__content" :src="item.ImageURL"
                     :alt="item.Product_Name"/>
              </div>
              <h4 v-if="item.Manufacturer" class="productListing__item__brand">{{item.Manufacturer}}</h4>
              <h5 v-if="item.Category_4" class="productListing__item__model">{{item.Category_4}}</h5>
              <div v-if="item.Product_Name" class="productListing__item__description">{{item.Product_Name}}</div>
              <div v-if="item.delivery" class="productListing__item__delivery">
                <img :src="item.delivery.icon" :alt="item.delivery.label">
                <span>{{item.delivery.label}}</span>
              </div>
              <div v-if="item.Price" class="productListing__item__price">&euro; {{item.Price}}</div>
              <div class="productListing__item__addBtn"
                   @click="retrieveNextStep(config.id, config.answers[0].id, false, item.Product_ID)">
                <span>Aggiungi al carrello</span>
              </div>

            </div>


            <div class="productListing__alert" v-if="noProducts">
              <h4>Nessun prodotto corrisponde ai criteri da te selezionati.</h4>
              <div class="productListing__continue" v-if="continueBtn">
                <span class="productListing__continue__span" @click="retrieveNextStep(config.id, continueBtn.id, false)">
                  {{continueBtn.text}}
                </span>
              </div>
            </div>

          </div>
        </div>

        <div v-if="checkResolution && !noProducts" class="productListing__paginator">
          <div class="productListing__paginator__list">
            <ul>
              <li v-if="checkTotalPages" :class="{'is-disabled': !checkFirstVisible}" @click="movePagePrev">
                <span>&laquo</span>
              </li>
              <li v-for="(page, index) in config.paginator.totalPages"
                  v-if="checkIfInRange(index)"
                  :data-index="index"
                  :class="{'is-active': checkIfCurrentPage(index)}"
                  @click.self="checkPage">
                <span>{{index + 1}}</span>
              </li>
              <li v-if="checkTotalPages" :class="{'is-disabled': !checkLastVisible}" @click="movePageNext">
                <span>&raquo</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false,
        configData: '',
        continueBtn: null,
        previousBrand: false,
        hasTransitions: true,
        collapsedFilters: true,
        paging: {
          firstVisible: 0,
          lastVisible: 0,
          firstPage: 0,
          lastPage: 0
        }
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    computed: {
      noProducts(){
        if (this.config.products && this.config.products.length == 0) {
          if(this.config.suggested){
            return this.config.suggested.length == 0;
          }
          return true;
        }
      },
      checkTotalPages(){
        return this.config.paginator.totalPages > 5;
      },
      checkFirstVisible(){
        return (this.paging.firstVisible > this.config.paginator.currentPage - 1 || this.paging.firstVisible > this.paging.firstPage);
      },
      checkLastVisible(){
        return (this.paging.lastVisible < this.config.paginator.totalPages - 1 && this.config.paginator.totalPages > 6);
      },
      checkTransition(){
        return this.$store.state.hasAnimations ? 'cycleFromLeft' : 'noAnimation';
      },
      getBrand(){
        return this.previousBrand.toUpperCase();
      },
      checkImgSize(){
        var img = $('.productListing__item__img__content');
        var imgHeight = img.innerHeight();
        var imgWidth = img.innerWidth();
        console.log(imgHeight);
        console.log(imgWidth);
        return imgHeight > imgWidth;
      },
      checkResolution(){
        return (window.innerWidth <= 768) && this.config.paginator;
      }
    },
    methods: {
      toggleFiltersBox(){
        this.collapsedFilters = !this.collapsedFilters;
      },
      isFiltersCollapsed(){
        var vm = this;
        if (vm.collapsedFilters) {
          return false;
        }
        else {
          return true;
        }
      },
      isOptionSelected(item){
        return item.selected;
      },
      checkPaging(){
        var vm = this;
        vm.paging.lastPage = vm.config.paginator.totalPages - 1;
        vm.paging.firstVisible = vm.config.paginator.currentPage - 1;
        if (vm.paging.lastPage > (vm.paging.firstVisible + 4)) {
          vm.paging.lastVisible = (vm.paging.firstVisible + 4);
        }
        else {
          vm.paging.lastVisible = vm.paging.lastPage;
        }
      },
      checkIfInRange(index){
        return index >= this.paging.firstVisible && index <= this.paging.lastVisible || this.config.paginator.totalPages <= 5;
      },
      movePageNext(){
        var vm = this;
        vm.paging.firstVisible = vm.paging.firstVisible + 1;
        vm.paging.lastVisible = vm.paging.lastVisible + 1;
      },
      movePagePrev(){
        var vm = this;
        vm.paging.firstVisible = vm.paging.firstVisible - 1;
        vm.paging.lastVisible = vm.paging.lastVisible - 1;
      },
      checkPage(e){
        var vm = this;
        var el = $(e.target);
        vm.config.paginator.currentPage = el.data('index') + 1;
        vm.sendFiltersAndPage();
      },
      sendFiltersAndPage(fromFilters){
        var vm = this,
          filterBrand,
          filterBrandHeader,
          filterBrandValue,
          filterBrandOptions,
          filterSecondary,
          filterSecondaryHeader,
          filterSecondaryValue,
          filterSecondaryOptions,
          filterPrice,
          filterPriceHeader,
          filterPriceValue,
          filterPriceOptions,
          filterClass,
          filterClassHeader,
          filterClassValue,
          filterClassOptions,
          option = null,
          i = 0;

        filterBrand = $('.productListing__filter[data-type="brand"]');
        filterSecondary = $('.productListing__filter[data-type="secondary"]');
        filterPrice = $('.productListing__filter[data-type="price"]');
        filterClass = $('.productListing__filter[data-type="class"]');

        filterBrandHeader = filterBrand.find('.productListing__filter__header');
        filterSecondaryHeader = filterSecondary.find('.productListing__filter__header');
        filterPriceHeader = filterPrice.find('.productListing__filter__header');
        filterClassHeader = filterClass.find('.productListing__filter__header');

        filterBrandOptions = filterBrand.find('.productListing__filter__option');
        filterSecondaryOptions = filterSecondary.find('.productListing__filter__option');
        filterPriceOptions = filterPrice.find('.productListing__filter__option');
        filterClassOptions = filterClass.find('.productListing__filter__option');

        for (i = 0; i < filterBrandOptions.length; i++) {
          option = filterBrandOptions[i];
          if ($(option).data('selected') == true) {
            filterBrandValue = $(option).data('value');
          }
        }

        option = null;

        for (i = 0; i < filterSecondaryOptions.length; i++) {
          option = filterSecondaryOptions[i];
          if ($(option).data('selected') == true) {
            filterSecondaryValue = $(option).data('value');
          }
        }

        option = null;

        for (i = 0; i < filterPriceOptions.length; i++) {
          option = filterPriceOptions[i];
          if ($(option).data('selected') == true) {
            filterPriceValue = $(option).data('value');
          }
        }

        option = null;

        for (i = 0; i < filterClassOptions.length; i++) {
          option = filterClassOptions[i];
          if ($(option).data('selected') == true) {
            filterClassValue = $(option).data('value');
          }
        }

        //Get filters
        var filters = {};
        filters.brand = filterBrandValue || '';
        filters.secondary = filterSecondaryValue || '';
        filters.price = filterPriceValue || '';
        filters.class = filterClassValue || '';

        //Get page
        var page = vm.config.paginator.currentPage;

        if (fromFilters != undefined && fromFilters) {
          page = 1;
        }

        var data = {
          filters: filters,
          page: page
        };

        vm.$store.state.hasAnimations = false;
        vm.$store.state.isApplicationLoading = true;
        $.ajax({
          type: 'GET',
          url: vm.$store.state.routes.resultsURL,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          data: data,
          success: function (res) {
            vm.$store.state.isApplicationLoading = false;
            vm.reloadQuestion(function () {
              vm.updateParentProps();
            }, res);
          }
        })
      },
      isInCart(item){
        return item.alreadyInCart;
      },
      checkIfCurrentPage(itemIdx){
        return (this.config.paginator.currentPage - 1) == itemIdx;
      },
      checkIfOverflow(){
        var viewHeight = $('.productListing').innerHeight();
        var windowHeight = $(window).innerHeight();
        var footerHeight = $('.footer').innerHeight();
        var headerHeight = $('.header').innerHeight();
        var visibleHeight = windowHeight - footerHeight - headerHeight;
        if (viewHeight > visibleHeight) {
          $('.productListing').addClass('has-overflow');
        }
      },
      getSelectedOption(key){
        var vm = this;
        var res;
        for (var i = 0; i < vm.config.filters.length; i++) {
          if (vm.config.filters[i].key == key) {
            (function () {
              for (var j = 0; j < vm.config.filters[i].options.length; j++) {
                if (vm.config.filters[i].options[j].selected) {
                  res = vm.config.filters[i].options[j].label;
                  var filter = $('.productListing__filter[data-type="' + key + '"]');
                  filter.data('index', j);
                }
              }
            })();
          }
        }
        return res;
      },
      toggleFilter(filter){
        var allFilters = $('.productListing__filter');
        for (var i = 0; i < allFilters.length; i++) {
          var filterContent = $(allFilters[i]).find('.productListing__filter__content');
          if ($(allFilters[i]).data('type') == filter) {
            filterContent.toggleClass('is-open');
          }
          else {
            filterContent.removeClass('is-open');
          }
        }
      },
      closeFilter(filter, value, skipCall){
        var vm = this;
        var filterBlock = $('[data-type="' + filter + '"]');
        var filterContent = filterBlock.find('.productListing__filter__content');
        var filterPlaceholder = filterBlock.find('.productListing__filter__header');
        var allOptions = filterContent.find('.productListing__filter__option');
        $.each(allOptions, function (i, el) {
          $(el).data('selected', '');
        });
        var selectedOption = filterContent.find('[data-value="' + value + '"]');
        selectedOption.data('selected', true);

        var selectedIndex = selectedOption.data('index');
        filterBlock.data('index', selectedIndex);
        filterPlaceholder.text(selectedOption.text());
        filterContent.removeClass('is-open');
        if (skipCall) {
          return;
        }
        vm.sendFiltersAndPage(true);
      },
      closeAllFilter(){
        var filterContent = $('.productListing__filter__content');
        $.each(filterContent, function (i, el) {
          $(el).removeClass('is-open');
        });
      },
      checkIfFilterSelected(){
        var vm = this;
        for (var i = 0; i < vm.config.filters.length; i++) {
          console.log(vm.config.filters[i]);
        }
      },
      closeInfoBox(){
        $('.productListing__info').hide();
      },
      checkIfProductIsInCart(arr){
        var vm = this;
        for (var i = 0; i < arr.length; i++) {
          var obj = arr[i];
          for (var j = 0; j < vm.config.products.length; j++) {
            var product = vm.config.products[j];
            product.alreadyInCart = product.Product_ID == obj.Product_ID;
            if (product.alreadyInCart) {
              vm.previousBrand = product.Manufacturer;
              vm.closeFilter('brand', vm.previousBrand.toLowerCase(), true);
            }
          }
        }
      },
      checkCart(){
        var vm = this;
        $.ajax({
          method: 'GET',
          url: vm.$store.state.routes.cart.get,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          success: function (res) {
            vm.configData = res.data.items;
            vm.updateProps();
          }
        })
      },
      matchHeight(){
        var items = $('.productListing__item'),
          maxHeight = 0,
          i = 0;

        resizeElements();

        function resizeElements() {
          maxHeight = 0;
          items.height('auto');
          if (window.innerWidth >= 768) {
            for (i = 0; i < items.length; i++) {
              var itemHeight = $(items[i]).outerHeight();
              if (itemHeight > maxHeight) {
                maxHeight = itemHeight;
              }
            }
            for (i = 0; i < items.length; i++) {
              $(items[i]).height(maxHeight);
            }
          }
          else {
            for (i = 0; i < items.length; i++) {
            }
            $(items[i]).height('auto');
          }
        }

        $(window).on('resize', resizeElements);

      },
      updateProps(){
        var vm = this;
        //Update component data when component is mounted or updated
        vm.config = vm.dataObj;
        vm.checkIfProductIsInCart(vm.configData);
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          vm.$forceUpdate();
        }
        setTimeout(function () {
          vm.$store.state.hasAnimations = true;
        }, 1010);
      },
      retrieveNextStep(questionId, answerId, isDisabled, id){
        if (!isDisabled) {
          var vm = this;

          if(typeof id !== 'undefined'){

            if(vm.config.amount){
              var amount = vm.config.amount;
            }
            console.log(vm.config);

            var data = {
              asynchronousAddToCart: true,
              SKU: id,
              qtyParamName: 1
            };

            var str = 'Quantity_' + data.SKU;

            data[str] = amount || 1;

            console.log(data);

            // Make AJAX call to add product to cart
            $.ajax({
              method: 'GET',
              url: vm.$store.state.routes.cart.add,
              crossDomain: true,
              xhrFields: {
                withCredentials: true
              },
              data: data,
              success: function (res) {
                // Make AJAX call to retrieve next summary node
                // @summaryId {integer}:
                //    is the current node ID
                // @answerId {integer}:
                //    is the chosen answer ID
                vm.$store.state.productListing.push(id);
                vm.makeNextCall(questionId, answerId, function () {
                  vm.updateParentProps();
                }, id)
              },
              error: function () {

              }
            });
          }
          else{
            vm.continueBtn.disabled = true;
            vm.makeNextCall(questionId, answerId, function () {
              vm.updateParentProps();
            })
          }

        }
      }
    },
    mounted(){
      var vm = this;
      vm.checkCart();
      setTimeout(function () {
        vm.checkPaging();
        vm.matchHeight();
      }, 250);
      setTimeout(function () {
        vm.checkIfOverflow();
        console.log(vm.config);
        if(vm.config.answers.length > 1){
          vm.continueBtn = vm.config.answers[1];
        }
      }, 1001);
    },
    updated(){
      var vm = this;
      //vm.checkPaging();
      setTimeout(function () {
        vm.checkPaging();
        vm.matchHeight();
      }, 250);
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ecommerce/ProductListing.vue